import axios from "@/plugins/axios";

export default {
  namespaced: true,

  state: {
    events: [],
  },
  mutations: {
    SET_EVENTS(state, value) {
      state.events = value
    },
  },
  getters: {
    getEvents(state) {
      return state.events
    },
  },
  actions: {
    async getEventsByEquipment({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.get('/events/' + data).then(res => {
          commit('SET_EVENTS', res.data)
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async downloadCsvDataForEquipment({ rootState }, { data, onProgress }) {
      return new Promise((resolve, reject) => {
        const token = rootState.auth.token;
        const baseURL = process.env.VUE_APP_BASE_URL;
        const url = `${baseURL}/events/csv/export-by-equipment/${data.id}`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = '';
          let csv = '';
          let lastProgress = 0;

          const readChunk = () => {
            reader.read().then(({ done, value }) => {
              if (done) {
                if (csv) {
                  resolve(csv);
                } else {
                  reject(new Error('Aucune donnée CSV reçue'));
                }
                return;
              }

              buffer += decoder.decode(value, { stream: true });
              const lines = buffer.split('\n');
              buffer = lines.pop() || '';

              for (const line of lines) {
                if (line.startsWith('data: ')) {
                  try {
                    const jsonStr = line.substring(6).trim();
                    if (!jsonStr) continue; // Ignorer les lignes vides
                    
                    const event = JSON.parse(jsonStr);
                    
                    if (event.csv) {
                      csv = event.csv;
                    }
                    
                    // Toujours mettre à jour la progression si elle est présente
                    if (onProgress && typeof onProgress === 'function') {
                      if (event.progress !== undefined && event.progress !== null) {
                        lastProgress = event.progress;
                        onProgress(event.progress, event.message || 'Export en cours...');
                      } else if (event.message) {
                        // Si pas de progression mais un message, garder la progression actuelle
                        onProgress(lastProgress, event.message);
                      }
                    }
                  } catch (e) {
                    console.error('Erreur lors du parsing de l\'événement SSE:', e, 'Line:', line);
                  }
                }
              }

              readChunk();
            }).catch(error => {
              reject(error);
            });
          };

          readChunk();
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    async deleteEquipmentDataWithRange(_, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.post('/events/delete/' + data.id, data).then(res => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async getLastEventsByEquipment({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.get('/events/last/' + data).then(res => {
          commit('SET_EVENTS', res.data)
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async downloadCsvDataForSites({ rootState }, { data, onProgress, onSiteCsv }) {
      return new Promise((resolve, reject) => {
        const token = rootState.auth.token;
        const baseURL = process.env.VUE_APP_BASE_URL;
        const url = `${baseURL}/events/csv/export-by-sites`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = '';

          const readChunk = () => {
            reader.read().then(({ done, value }) => {
              if (done) {
                resolve();
                return;
              }

              buffer += decoder.decode(value, { stream: true });
              const lines = buffer.split('\n');
              buffer = lines.pop() || '';

              for (const line of lines) {
                if (line.startsWith('data: ')) {
                  try {
                    const jsonStr = line.substring(6);
                    const event = JSON.parse(jsonStr);
                    
                    // Si un CSV de site est disponible, le télécharger
                    if (event.siteCsv && event.siteCsv.csv && onSiteCsv && typeof onSiteCsv === 'function') {
                      onSiteCsv(event.siteCsv);
                    }
                    
                    // Mettre à jour la progression avec les informations du site si disponibles
                    if (onProgress && typeof onProgress === 'function') {
                      onProgress(event.progress || 0, event.message || '', event.siteInfo);
                    }
                  } catch (e) {
                    console.error('Erreur lors du parsing de l\'événement SSE:', e);
                  }
                }
              }

              readChunk();
            }).catch(error => {
              reject(error);
            });
          };

          readChunk();
        })
        .catch(error => {
          reject(error);
        });
      });
    },
  },
}
